<template>
  <b-form-group
    :id="id + 'group'"
    :label="(label)? label : $t('LABEL.' + fieldname)"
    :label-for="id"
    :state="state"
    :invalid-feedback="invalidFeedback"
    :description="description"
    :label-cols-sm="labelCols"
    :label-align-sm="labelAlign"
    :content-cols-sm="contentCols"
    class="cp-textfield"
  >
    <div v-if="viewmode">
      {{ value }}
    </div>
    <b-form-input
        v-if="!viewmode"
        class="form-control"
        type="password"
        :id="id"
        :state="state"
        :value="value"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="value => updateValue(value)"
    />
  </b-form-group>
</template>

<script>
import commonValidate from '@/mixins/commonValidate.js'

export default {
  mixins: [commonValidate],
  props: {
    id: { type: String, required: true },
    fieldname: { type: String, required: true },
    label: { type: String, default: null, required: false },
    value: { type: String, required: true },
    placeholder: { type: String, default: '', required: false },
    description: { type: String, default: '', required: false },
    viewmode: { type: Boolean, default: false, required: false },
    minlength: { type: Number, default: 8, required: false },
    maxlength: { type: Number, default: 40, required: false },
    validators: { type: Array, defaule: [], required: false },
    refvalue: { type: String, defaule: '', required: false },
    disperror: { type: Boolean, default: false, required: false },
    labelCols: { type: Number, default: 3, required: false },
    labelAlign: { type: String, default: 'left', required: false },
    contentCols: { type: Number, default: 9, required: false }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/fields/PasswordField.vue